import { useEffect, useState } from 'react';
import { Button, Icon } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';
import { useSipWebsocket } from 'app/protocol/SipWebsocketProvider';
import Command from 'app/protocol/Command';
import QueryDeviceStatusCommand from 'app/protocol/status/QueryDeviceStatusCommand';
import DeviceEditService from '../service/DeviceEditService';

function DeviceTechnical(props) {
	const { getValues, setValue } = useFormContext();
	const { sipId, initialized, message, sendMessage } = useSipWebsocket();

	useEffect(() => {
		if (message && message.command === Command.PUBLISH_DEVICE_STATUS) {
			handleStatusMessage(message);
		}
	}, [message]);

	const queryDevice = () => {
		if (sipId) {
			sendMessage(new QueryDeviceStatusCommand(sipId, getValues('externalId')));
			DeviceEditService.updateTechnical(getValues('externalId'));
		}
	};

	const handleStatusMessage = cmd => {
		setValue('batteryLevel', cmd.batteryLevel !== null ? Math.ceil(cmd.batteryLevel * 100) / 100 : null);
		setValue('boardTemperature', cmd.boardTemperature !== null ? Math.ceil(cmd.boardTemperature * 100) / 100 : null);
		setValue('model', cmd.model);
		setValue('version', cmd.version);
		setValue('uptime', cmd.uptime);
		setValue('mac', convertBytesToMac(cmd.mac));
		setValue('ip', convertBytesToIP(cmd.isIPv6, cmd.ip));
	};

	const convertBytesToMac = bytes => {
		const result = [];
		bytes.forEach(byte => {
			const unsignedByte = byte & 0xff;
			if (unsignedByte < 16) {
				result.push(`0${unsignedByte.toString(16)}`);
			} else {
				result.push(unsignedByte.toString(16));
			}
		});
		return result.join(':');
	};

	const convertBytesToIP = (isIPv6, bytes) => {
		if (isIPv6) {
			const result = [];
			let pos = 0;
			bytes.forEach(byte => {
				const unsignedByte = byte & 0xff;
				let hex = null;
				if (unsignedByte < 16) {
					hex = `0${unsignedByte.toString(16)}`;
				} else {
					hex = unsignedByte.toString(16);
				}
				if (result.length === pos) result[pos - 1] = result[pos - 1] + hex;
				else result.push(hex);
				pos += 1;
			});
			return result.join(':');
		}
		return bytes.join('.');
	};

	return (
		<div className="sm:ml-6 flex justify-end items-center">
			<Button className="whitespace-nowrap mx-4" variant="contained" color="secondary" onClick={() => queryDevice()} startIcon={<Icon className="hidden sm:flex">refresh</Icon>} disabled={!initialized}>
				Refresh
			</Button>
		</div>
	);
}

export default DeviceTechnical;
